<ul class="list-unstyled">
  <ng-container *ngFor="let item of navItems">
    <li *ngIf="!item.children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <a *ngIf="item.route" [routerLink]="item.route" [queryParams]="item.queryParams">{{ item.label }}</a>
      <a *ngIf="item.downloadPath" href="javascript:void(0)" (click)="onDownload(item)">{{ item.label }}</a>
    </li>
    <li *ngIf="item.children">
      <a href="javascript:void(0)" (click)="item.expanded = !item.expanded">
        {{ item.label }}
        <span class="float-end">{{ item.expanded ? '▾' : '▸' }}</span>
      </a>
      <ul *ngIf="item.expanded" class="list-unstyled ps-3">
        <li *ngFor="let child of item.children" routerLinkActive="active">
          <a [routerLink]="child.route" [queryParams]="child.queryParams">{{ child.label }}</a>
        </li>
      </ul>
    </li>
  </ng-container>
</ul>
